<template>
  <section class="display-wall">
    <div class="list">
      <div class="item" v-for="(item, index) in partnersList" :key="index">
        <div
          class="sub-item"
          v-for="(subItem, subIndex) in item"
          :key="subIndex"
        >
          <a target="_blank" :href="subItem.href">
            <img
              class="logo"
              :src="subItem.logo"
              :alt="subItem.name"
              :title="subItem.name"
            />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { partnerOptionList } from "@/utils";

export default {
  name: "PartnerDisplayWall",
  data() {
    return {
      partnerOptionList,
      dataList: [
        ["kucoin", "gateio", "deribit", "phemex", "cobo"],
        ["bitrue", "bitmart", "ellipal", "lbank", "blocto"],
        ["cointiger", "coinw", "zoomex", "probit", "valens"],
        ["bingx", "bitpush", "xbank"]
      ]
    };
  },
  computed: {
    partnersList() {
      return this.dataList.map(data => {
        return data.map(item => {
          return this.partnerOptionList.find(({ key }) => {
            return item === key;
          });
        });
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.display-wall {
  .list {
    .item {
      width: 100%;
      display: flex;
      justify-content: center;

      &:not(:last-child) {
        margin-bottom: 1rem;
      }
      .sub-item {
        &:not(:last-child) {
          margin-right: 1rem;
        }
        width: 14.25rem;
        height: 4.5625rem;
        background: white;
        border-radius: 0.9375rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .logo {
          width: 10rem;
        }
      }
    }
  }
}
</style>
